module.exports = __webpack_public_path__ + "img/sp-icon-purchase-close.ecea626f.svg";